var exports = {
  "kL": "x127c5a35--10b529--container",
  "iE": "x127c5a35--10b529--wrapper",
  "Qs": "x127c5a35--10b529--content",
  "r1": "x127c5a35--10b529--content-folder",
  "DD": "x127c5a35--10b529--title",
  "h_": "x127c5a35--10b529--description",
  "Kk": "x127c5a35--10b529--icon",
  "jR": "x127c5a35--10b529--empty-background",
  "KG": "x127c5a35--10b529--empty-newbuilding-background",
};

module.exports = exports;
